import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function SdCardIcon(props: IconProps) {
    return <Icon {...props} iconKey={"sd_card"}/>
}
